"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftMessageValidationUtils = void 0;

var yup = _interopRequireWildcard(require("yup"));

var _gifting = require("../gifting.types");

var CMF_VALIDATION_RULES = {
  [_gifting.MessageFields.Message]: {
    min: {
      value: 10,
      msg: 'The message should be longer than 10 chars.'
    },
    max: {
      value: 1000,
      msg: 'The message should not exceed 1000 chars.'
    },
    required: 'The message needs to be filled in.'
  }
};
var giftMessageValidationSchema = yup.object().shape({
  [_gifting.MessageFields.Message]: yup.string().default('').trim().min(CMF_VALIDATION_RULES[_gifting.MessageFields.Message].min.value, CMF_VALIDATION_RULES[_gifting.MessageFields.Message].min.msg).max(CMF_VALIDATION_RULES[_gifting.MessageFields.Message].max.value, CMF_VALIDATION_RULES[_gifting.MessageFields.Message].max.msg).required(CMF_VALIDATION_RULES[_gifting.MessageFields.Message].required)
});
var giftMessageDefaultValues = giftMessageValidationSchema.cast({
  [_gifting.MessageFields.Message]: ''
});
var GiftMessageValidationUtils = {
  giftMessageValidationSchema,
  giftMessageDefaultValues
};
exports.GiftMessageValidationUtils = GiftMessageValidationUtils;